<template>
    <footer class="full_footer">
        <div class="container top-footer py-4">
            <div class="row">
                <div class="col-md-3">
                    <img class="img-fluid" src="@/assets/logo/logo.png" alt="">

                </div>
                <div class="col-md-3">
                    <p>
                        A simple way to travel and relocate is to talk to the expert and avoid waisting money in many
                        forms.
                    </p>
                    <div class="social-icons">
                        <a class="p-1" style="color: white;" href="https://www.facebook.com/share/1axa2n2vz5/"><i class="fab fa-2x fa-facebook"></i></a>
                       <a
  class="p-1"
  style="color: white;"
  href="https://www.tiktok.com/@gaaafricainternational"
  target="_blank"
  rel="noopener noreferrer"
>
  <i class="fab fa-2x fa-tiktok"></i>
</a>

                    </div>

                </div>

                <div class="col-md-3">
                    <h3>Our Services</h3>
                     <a href="/">Home</a><br>
                      <a href="/about">About</a><br>
                    <a  href="/travel-consultation">Travel Consultation</a><br>
                    <a href="visa-facilitation">Visa facilitation</a><br>
                </div>

                <div class="col-md-3">
                    <h3>Contact us</h3>
                    <a>info@gaaafricainternational.co.za</a><br>
                    <div class="embed-responive embed-responsive-16by9">
                        <iframe class="embed-responsive-item" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3593.625972728498!2d28.235546900000003!3d-25.74987979999999!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1e9561b93e08ba81%3A0x8e8f7943b41dd8c5!2s1122%20Burnett%20St%2C%20Hatfield%2C%20Pretoria%2C%200028!5e0!3m2!1sen!2sza!4v1724239324625!5m2!1sen!2sza" frameborder="0"></iframe>             
                    </div>
                    
                </div>


            </div>

        </div>

    </footer>
</template>

<style scoped>
.full_footer {
    background-color: grey;
    bottom: 0;
    width: 100%;
    
}

.top-footer {
    color: #f3f3f3;
}

.bottom-nav {
    background-color: white;
    color: black;
    padding: 20px 0;
    position: fixed;
    bottom: 0;
    width: 100%;
    text-align: center;
}

.container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    /* Center content vertically */
}

.contact-info {
    display: flex;
    justify-content: center;
    /* Center align the contact-info */
    padding-bottom: 10px;
    /* Space between contact-info and social-media */
}

.contact-details {
    display: flex;
    align-items: center;
    max-width: 800px;
    /* Control the width of the contact-info */
}

.contact-text {
    margin-left: 20px;
}

.footer-logo {
    height: 50px;
    margin-right: 20px;
    /* Add margin to space out logo from text */
}

.social-media {
    display: flex;
    justify-content: center;
    /* Center align social media icons */
    gap: 10px;
    /* Space between social icons */
}

.social-icon img {
    height: 24px;
    width: 24px;
}
</style>